import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import ConstructionsRepository from '@/shared/http/repositories/configuration/constructions'
import ConstructionsModel from '@/shared/models/configuration/constructionsmodel'
import ConstructionsForms from './constructions-form'

export default {
  name: 'constructions',
  mixins: [ActionsForm],
  data () {
    return {
      data: ConstructionsModel,
      form: ConstructionsForms
    }
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      /*
      loading.push()
      ConstructionsRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
        */
    },
    onCreate () {
      loading.push()
      ConstructionsRepository.Create(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      ConstructionsRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      ConstructionsRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/constructions/constructions.js